import Group from './group';
import Textarea from './textarea'
import Search from './search'
import Input from './input';

Input.Group = Group;
Input.Textarea = Textarea;
Input.Search = Search;

export default Input;
